import { rawTimeZones } from "@vvo/tzdb";

const timezoneToCountry = new Map<string, string>(
  rawTimeZones.flatMap((tz) => tz.group.map((name) => [name, tz.countryCode] as const)),
);

/**
 * Derives an ISO 3166-1 alpha-2 country code from an IANA timezone identifier.
 *
 * Used on web where `expo-localization` does not provide a region code.
 * Returns an empty string when the timezone is unrecognised.
 */
export function getCountryCodeFromTimezone(timezone: string): string {
  return timezoneToCountry.get(timezone) ?? "";
}
